import { useIsRouting, useParams } from "@solidjs/router";
import { Match, Show, Switch } from "solid-js";
import BrandL2TataDigitalView from "~/views/webstore/brandl2_tata_digital/brand_l2_page";
import { BrandL2TelescopeView } from "~/views/rnr_telescope/brand_l2_telescope/brand_l2_telescope_view";
import BrandL2WebstoreTelescope from "~/views/webstore/brandl2_webstore_telescope/brandl2_webstore_telescope";
import { useWebStoreContext } from "~/context/webstore_context";
import { FullScreenLoaderTelescope } from "~/components/webstore_telescope/full_screen_loader";
import { clientIdConfig } from "~/data/partner_config";

export default function BrandPage() {
  const params = useParams();
  const isRouting = useIsRouting();
  const { getMode, getClientId } = useWebStoreContext();

  const brandKey = () => params.brandKey;
  if (!brandKey()) {
    throw new Error("Brand key is required");
  }

  return (
    <>
      <Show when={!isRouting()} fallback={<FullScreenLoaderTelescope />}>
        <Switch>
          {/* Use classic design for other clients */}
          <Match when={getClientId() === clientIdConfig.tdClientId}>
            <BrandL2TataDigitalView brandKey={brandKey()!} />
          </Match>
          {/* Use Webstore Telescope Design System when feature flag is enabled */}
          <Match when={true}>
            <Switch>
              <Match when={getMode() === "hubble"}>
                <BrandL2WebstoreTelescope />
              </Match>
              <Match when={getMode() === "rnr"}>
                <BrandL2TelescopeView brandKey={brandKey()!} />
              </Match>
            </Switch>
          </Match>
        </Switch>
      </Show>
    </>
  );
}
